import clsx from 'clsx';
import { FC } from 'react';
import InfoIcon from '@mui/icons-material/Info';

import { LogShipmentStatus } from './LogShipmentStatus';
import { ILogShipmentItemProps } from './types';

export const LogShipmentItem: FC<ILogShipmentItemProps> = ({ log }) => (
  <div className='pb-36 last:pb-0 flex relative group/shipment gap-16'>
    <div className={clsx('w-36 h-36 rounded-5 flex items-center justify-center bg-neutral-10')}>
      <InfoIcon sx={{ color: '#9F9F9F', fontSize: 20 }} />
    </div>
    <div className='flex-1'>
      <div className='flex flex-col gap-8'>
        <h2 className='text-14 font-medium'>Shipment {log?.shipmentNumber}</h2>
      </div>

      <div className='mt-16 rounded-12 py-12 px-16 bg-neutral-10'>
        {log?.activityLogs?.map((log) => <LogShipmentStatus key={`shipment-status-${log?.createdOn}`} log={log} />)}
      </div>
    </div>
    <div className='group-last/shipment:hidden absolute left-18 top-[36px] bottom-0 w-0 border-l border-dashed border-neutral-20' />
  </div>
);
